import React, {useContext, useMemo} from 'react'
import {OrgCustomizationContext} from "../../themes/OrgCustomizationProvider";
import {FormControl, FormHelperText, FormLabel, Grid, TextField, Typography} from "@mui/material";

type PatientWeightInputProps = {
    errors: string | undefined
    units: string | undefined
    setUnits: React.Dispatch<'lbs' | 'kg'>
    weight: string | undefined | null
    onChange: React.Dispatch<string>
}

const PatientWeightInput: React.FC<PatientWeightInputProps> = (props) => {
    const {questionsConfiguration, t} = useContext(OrgCustomizationContext)
    const show = useMemo(() => questionsConfiguration.patient_weight
            ? questionsConfiguration.patient_weight.show
            : true
        , [questionsConfiguration.patient_weight])

    if (!show) return null

    return <FormControl sx={{mb: 2}}>
        <FormLabel sx={{mb: 1}}>{t('pi_patient_weight')}:</FormLabel>
        <Grid container>
            <Grid>
                <TextField
                    sx={{width: '9rem'}}
                    error={!!props.errors}
                    size='small'
                    value={Number(props.weight?.split(' ')[0]) || ''}
                    onChange={(e) => props.onChange(e.target.value)}
                    type='number'
                    inputProps={{maxLength: 10}}
                    onInput={(e: any) => {
                        const maxLen: number = 10;
                        const sliceEnd: number = maxLen;
                        const val: string = String(e.target.value)
                        const len: number = val.length

                        e.target.value = len > maxLen ? val.slice(0, sliceEnd) : val;
                    }}
                />
            </Grid>
            <Typography
                style={{
                    marginLeft: '1rem',
                    marginRight: 4,
                    marginTop: 'auto',
                    marginBottom: 'auto',
                }}
                sx={props.units !== 'lbs' ? {textDecoration: 'underline', color: 'blue'} : {}}
                className='withHover'
                onClick={() => props.setUnits('lbs')}
            >
                lbs
            </Typography>
            <Typography
                style={{
                    marginTop: 'auto',
                    marginBottom: 'auto'
                }}
            >
                {" / "}
            </Typography>
            <Typography
                style={{
                    marginTop: 'auto',
                    marginBottom: 'auto',
                    marginLeft: 4
                }}
                sx={props.units !== 'kg' ? {textDecoration: 'underline', color: 'blue'} : {}}
                className='withHover'
                onClick={() => props.setUnits('kg')}
            >
                kg
            </Typography>
        </Grid>

        <FormHelperText>
            {t('pi_patient_age_helper_text')}
        </FormHelperText>
        <FormHelperText error={!!props.errors}>
            {props.errors}
        </FormHelperText>
    </FormControl>
}

export default PatientWeightInput